import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import SiteHeader from '@/components/generals/site-header'
import SiteFooter from '@/components/generals/site-footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col bg-ivory text-ink'>
            <a
                href='#main'
                className='sr-only rounded-full bg-chocolate px-5 py-2.5 text-sm font-medium text-ivory focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100]'
            >
                Skip to content
            </a>

            <SiteHeader />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
